module.exports = __webpack_public_path__ + "static/media/html-5.30a21c83.svg";